export default __webpack_public_path__ + "static/logo_tall-36b107c8b5a0cae7b100e72e10e49766.png";